module.exports = __webpack_public_path__ + "img/banner-2.9afecdf7.jpg";